/* Our Story — letter: pull-quote words light up as you scroll (scrubbed). */
(function () {
  function init(root) {
    if (!root || root._stLetter) return;
    root._stLetter = true;
    var D = window.Dozzee || {};
    if (D.reduce || !D.gsap) return;
    D.gsap(function (gsap, ST, Split) {
      var splits = [];
      root._stCtx = gsap.context(function () {
        root.querySelectorAll('[data-scrub]').forEach(function (el) {
          var sp = Split.create(el, { type: 'words' }); splits.push(sp);
          gsap.fromTo(sp.words, { opacity: 0.15 }, {
            opacity: 1, stagger: 0.1, ease: 'none',
            scrollTrigger: { trigger: el, start: 'top 85%', end: 'bottom 55%', scrub: true }
          });
        });
      }, root);
      root._stSplits = splits;
    });
  }
  function destroy(root) {
    if (!root) return;
    if (root._stCtx) root._stCtx.revert();
    (root._stSplits || []).forEach(function (s) { try { s.revert(); } catch (e) {} });
    root._stCtx = null; root._stSplits = null; root._stLetter = false;
  }
  function all(scope) { (scope || document).querySelectorAll('[data-section-type="story-letter"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-section-type="story-letter"]').forEach(destroy); });
})();
